// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file subscription/v1/addon.proto (package subscription.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file subscription/v1/addon.proto.
 */
export const file_subscription_v1_addon: GenFile =
    /*@__PURE__*/
    fileDesc(
        'ChtzdWJzY3JpcHRpb24vdjEvYWRkb24ucHJvdG8SD3N1YnNjcmlwdGlvbi52MSJNCgVBZGRvbhImCgRuYW1lGAEgASgOMhguc3Vic2NyaXB0aW9uLnYxLkZlYXR1cmUSDQoFdmFsdWUYAiABKAkSDQoFcHJpY2UYAyABKAEqowMKB0ZlYXR1cmUSFwoTRkVBVFVSRV9VTlNQRUNJRklFRBAAEhcKE01PTlRITFlfT1JERVJfTElNSVQQARIZChVCVUxLX1BSSU5USU5HX0VOQUJMRUQQAhIXChNIRUxQX0NFTlRFUl9TVVBQT1JUEAMSGAoUTUFQX1NFTEVDVE9SX0VOQUJMRUQQBBIdChlNVUxUSV9UUkFOU0xBVElPTl9FTkFCTEVEEAUSGgoWT1JERVJfVFJBQ0tJTkdfRU5BQkxFRBAGEhoKFlBBQ0tBR0VfUFJPVklERVJfTElNSVQQBxIZChVQSUNLVVBfUE9JTlRTX0VOQUJMRUQQCBIkCiBQUklOVElOR19TSElQUElOR19MQUJFTFNfRU5BQkxFRBAJEhMKD1NVUFBPUlRfRU5BQkxFRBAKEiAKHFVOTElNSVRFRF9TSElQUElOR19QUk9WSURFUlMQCxIYChRDSEVDS09VVF9NQVBfRElTUExBWRAMEhQKEFBBWU1FTlRfU0VUVElOR1MQDRIZChVNQVBfT05fVEhBTktfWU9VX1BBR0UQDkKEAQoTY29tLnN1YnNjcmlwdGlvbi52MUIKQWRkb25Qcm90b1ABWgQuL3BiogIDU1hYqgIPU3Vic2NyaXB0aW9uLlYxygIPU3Vic2NyaXB0aW9uXFYx4gIbU3Vic2NyaXB0aW9uXFYxXEdQQk1ldGFkYXRh6gIQU3Vic2NyaXB0aW9uOjpWMWIGcHJvdG8z'
    );

/**
 * @generated from message subscription.v1.Addon
 */
export type Addon = Message<'subscription.v1.Addon'> & {
    /**
     * @generated from field: subscription.v1.Feature name = 1;
     */
    name: Feature;

    /**
     * @generated from field: string value = 2;
     */
    value: string;

    /**
     * @generated from field: double price = 3;
     */
    price: number;
};

/**
 * Describes the message subscription.v1.Addon.
 * Use `create(AddonSchema)` to create a new message.
 */
export const AddonSchema: GenMessage<Addon> = /*@__PURE__*/ messageDesc(file_subscription_v1_addon, 0);

/**
 * @generated from enum subscription.v1.Feature
 */
export enum Feature {
    /**
     * @generated from enum value: FEATURE_UNSPECIFIED = 0;
     */
    FEATURE_UNSPECIFIED = 0,

    /**
     * @generated from enum value: MONTHLY_ORDER_LIMIT = 1;
     */
    MONTHLY_ORDER_LIMIT = 1,

    /**
     * @generated from enum value: BULK_PRINTING_ENABLED = 2;
     */
    BULK_PRINTING_ENABLED = 2,

    /**
     * @generated from enum value: HELP_CENTER_SUPPORT = 3;
     */
    HELP_CENTER_SUPPORT = 3,

    /**
     * @generated from enum value: MAP_SELECTOR_ENABLED = 4;
     */
    MAP_SELECTOR_ENABLED = 4,

    /**
     * @generated from enum value: MULTI_TRANSLATION_ENABLED = 5;
     */
    MULTI_TRANSLATION_ENABLED = 5,

    /**
     * @generated from enum value: ORDER_TRACKING_ENABLED = 6;
     */
    ORDER_TRACKING_ENABLED = 6,

    /**
     * @generated from enum value: PACKAGE_PROVIDER_LIMIT = 7;
     */
    PACKAGE_PROVIDER_LIMIT = 7,

    /**
     * @generated from enum value: PICKUP_POINTS_ENABLED = 8;
     */
    PICKUP_POINTS_ENABLED = 8,

    /**
     * @generated from enum value: PRINTING_SHIPPING_LABELS_ENABLED = 9;
     */
    PRINTING_SHIPPING_LABELS_ENABLED = 9,

    /**
     * @generated from enum value: SUPPORT_ENABLED = 10;
     */
    SUPPORT_ENABLED = 10,

    /**
     * @generated from enum value: UNLIMITED_SHIPPING_PROVIDERS = 11;
     */
    UNLIMITED_SHIPPING_PROVIDERS = 11,

    /**
     * @generated from enum value: CHECKOUT_MAP_DISPLAY = 12;
     */
    CHECKOUT_MAP_DISPLAY = 12,

    /**
     * @generated from enum value: PAYMENT_SETTINGS = 13;
     */
    PAYMENT_SETTINGS = 13,

    /**
     * @generated from enum value: MAP_ON_THANK_YOU_PAGE = 14;
     */
    MAP_ON_THANK_YOU_PAGE = 14,
}

/**
 * Describes the enum subscription.v1.Feature.
 */
export const FeatureSchema: GenEnum<Feature> = /*@__PURE__*/ enumDesc(file_subscription_v1_addon, 0);
